import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

export const PageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',   // navbar on top, body below
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: '#f5f6f8',
  minHeight: 0,
});

export const BodyWrapper = styled(Box)({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  minHeight: 0,
});

export const SidebarPaper = styled(Paper)({
  width: '300px',
  height: '100%',            // fills flex height
  boxShadow: '4px 0 8px -2px rgba(0,0,0,0.3)',
  borderRadius: 0,
  flexShrink: 0,
});

export const ContentContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',        // content controls scroll
  padding: '16px',
  minHeight: 0,
});

export const ScrollableSection = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  paddingRight: '8px',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});

export const VerticalPaddingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  paddingBottom: theme.spacing(2),
}));

export const SectionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  backgroundColor: '#fff',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));